import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/user';

const userApi = {
  login: (body) => {
    return axiosClient.post(url + '/login', body);
  },

  refreshToken: (body) => {
    return axiosClient.post(url + '/refreshToken', body);
  },

  update: (id, body) => {
    return axiosClient.put(url + `/${id}`, body);
  },

  create: (body) => {
    return axiosClient.post(url, body);
  },

  get: (params) => {
    return axiosClient.get(url, { params });
  },

  delete: (id) => {
    return axiosClient.delete(url + '/' + id);
  },

  changePassword: (body) => {
    return axiosClient.patch(url + '/change-password', body);
  },

  resetPassword: (id, body) => {
    return axiosClient.patch(url + `/${id}/reset-password`, body);
  },
};

export default userApi;
